import { createService } from "./createService"
import { SERVICE_INSTANCES } from "./serviceInstances"

const service = createService(SERVICE_INSTANCES.reports)

export const REPORTS_INSTANCE = service.instanceKey

export const REPORTS_ENDPOINTS = {
  GENERATE: "/admin/reports/view/generate",
  GET_DATE_RANGES: "/admin/reports/getdateranges",
  GET_DATE_PERIODS: "/admin/reports/getdateperiods",
  GET_GROUPING_TYPES: "/admin/reports/getgroupingtypes",
  GET_PAYROLLS: "/admin/reports/getpayrolls",
  VIEW_PREVIEW: "/admin/reports/view/preview",
  VIEW_CUSTOM_FIELDS: "/admin/reports/view/custom_fields",
  VIEW_EMPLOYEE_SUMMARY: "/admin/reports/view/employee_summary",
  SELECT_CUSTOM: "/admin/reports/selectcustom",
  GET_CUSTOM_VALUES: "/admin/reports/getcustomvalues",
  VIEW_BUILDER: "/admin/reports/view/builder",
  VIEW_CUSTOM: "/admin/reports/view/custom",
  VIEW_DOWNLOAD_CUSTOM: "/admin/reports/view/download_custom",
  UPDATE_TEMPLATE: "/admin/reports/update_template",
  UPDATE_TEMPLATE_NAME: "/admin/reports/update_template_name",
  SAVE_TEMPLATE: "/admin/reports/save_template",
  DELETE_TEMPLATE: "/admin/reports/delete_template",
  CHECK: "/admin/reports/check",
} as const

export const reportsService = {
  instanceKey: service.instanceKey,

  generate: (id: string) => service.get(REPORTS_ENDPOINTS.GENERATE, { id }),
  getDateRanges: () => service.get(REPORTS_ENDPOINTS.GET_DATE_RANGES),
  getDatePeriods: (id: string) =>
    service.get(`${REPORTS_ENDPOINTS.GET_DATE_PERIODS}?id=${id}`),
  getGroupingTypes: () => service.get(REPORTS_ENDPOINTS.GET_GROUPING_TYPES),
  getPayrolls: () => service.get(REPORTS_ENDPOINTS.GET_PAYROLLS),
  previewReport: (data: Record<string, any>) =>
    service.post(REPORTS_ENDPOINTS.VIEW_PREVIEW, data),
  viewCustomFields: () => service.get(REPORTS_ENDPOINTS.VIEW_CUSTOM_FIELDS),
  viewEmployeeSummary: () =>
    service.get(REPORTS_ENDPOINTS.VIEW_EMPLOYEE_SUMMARY),
  selectCustom: (params: Record<string, any>) =>
    service.get(REPORTS_ENDPOINTS.SELECT_CUSTOM, params),
  getCustomValues: () => service.get(REPORTS_ENDPOINTS.GET_CUSTOM_VALUES),
  viewBuilder: (id: string) =>
    service.get(REPORTS_ENDPOINTS.VIEW_BUILDER, { id }),
  viewCustom: (id: string, x: string) =>
    service.get(REPORTS_ENDPOINTS.VIEW_CUSTOM, { id, x }),
  updateTemplate: (id: string, data: Record<string, any>) =>
    service.post(`${REPORTS_ENDPOINTS.UPDATE_TEMPLATE}?id=${id}`, data),
  updateTemplateName: (id: string | number, description: string) =>
    service.post(
      `${REPORTS_ENDPOINTS.UPDATE_TEMPLATE_NAME}?id=${id}&description=${encodeURIComponent(
        description
      )}`
    ),
  saveTemplate: (data: Record<string, any>) =>
    service.post(REPORTS_ENDPOINTS.SAVE_TEMPLATE, data),
  deleteTemplate: (id: string | number) =>
    service.post(`${REPORTS_ENDPOINTS.DELETE_TEMPLATE}?id=${id}`),
  checkTemplateName: (description: string, id = "-1") =>
    service.get(REPORTS_ENDPOINTS.CHECK, { description, id }),
}
